module.exports = __webpack_public_path__ + "img/05-min.57b0e175.jpg";